import Container from 'react-bootstrap/Container'
import Table from 'react-bootstrap/Table'

import { FaFrown } from 'react-icons/fa'

import constantes from '../helpers/constanteHelper'
import { retornarTexto } from '../helpers/textoHelper'

function Contatos({ contatos, resolucaoMobile, idioma, exibirMenu }) {

    return (
        <div className='mb-5 animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <div className='mb-5'>
                <h1 className='mt-5 me-2 ms-2' style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>{retornarTexto(idioma, 'informacoesContato')}</h1>
            </div>

            <div style={{ width: resolucaoMobile ? '90vw' : '80vw', gap: '20px' }} className='mb-5 d-flex flex-column flex-wrap align-items-center justify-content-center'>
                <Container className='animate__animated animate__fadeIn ' >
                    <Table striped bordered hover responsive className='text-center' >
                        <thead style={{ height: '60px', verticalAlign: 'middle' }}>
                            <tr>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.ROXO_ABEA }}>{retornarTexto(idioma, 'tipoContato')}</th>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.ROXO_ABEA }}>{retornarTexto(idioma, 'descricao')}</th>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.ROXO_ABEA }}>{retornarTexto(idioma, 'contato')}</th>
                                <th style={{ width: '250px', backgroundColor: constantes.CORES.BRANCO_PADRAO, color: constantes.CORES.ROXO_ABEA }}>Link</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contatos.map((contato) =>
                                <tr>
                                    <td style={{ backgroundColor: constantes.CORES.ROXO_ABEA }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>{contato['Tipo de contato'] === '' ? '-' : contato['Tipo de contato']}</span></td>
                                    <td style={{ backgroundColor: constantes.CORES.ROXO_ABEA }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>{contato['Descrição'] === '' ? '-' : contato['Descrição']}</span></td>
                                    <td style={{ backgroundColor: constantes.CORES.ROXO_ABEA }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>{contato['Contato'] === '' ? '-' : contato['Contato']}</span></td>
                                    <td style={{ backgroundColor: constantes.CORES.ROXO_ABEA }}> <span style={{ color: constantes.CORES.BRANCO_PADRAO }}><a href={contato['Link'] === '' ? null : contato['Link']} rel="noreferrer" target="_blank">{contato['Link'] === '' ? '-' : contato['Link']}</a></span></td>
                                </tr>)}
                        </tbody>
                    </Table>

                    {contatos?.length > 0
                        ? <></>
                        : <div style={{ gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center'>
                            <FaFrown size={120} color={constantes.CORES.BRANCO_PADRAO} />

                            <span style={{ color: constantes.CORES.BRANCO_PADRAO }}>Não há dados para exibir.</span>
                        </div>
                    }

                </Container>
            </div>
        </div>
    );
}

export default Contatos